
import { defineComponent } from "@vue/runtime-core";
import axios from "axios";
import Button from "primevue/button";
import Ripple from "primevue/ripple";
import { useToast } from "primevue/usetoast";
import Toast from "primevue/toast";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "Profile",
  components: {
    Button,
    Toast
  },
  setup() {
    const toast = useToast();
      const showSuccess = () => {
        toast.add({
          severity: "success",
          summary: "Выполнено!",
          detail: "Обращение обновлено",
          life: 3000,
        });
      };
    function getSubscribeInfo() {
      const roles = sessionStorage.getItem("roles");
      if (roles !== null && roles.includes("Subscribers")) {
        return true;
      } else {
        return false;
      }
    }
    function getUserData() {
      const data = sessionStorage.getItem("userInfo");
      if (data !== null) {
        return JSON.parse(data);
      }
    }
    function getUserName() {
      const data = sessionStorage.getItem("userName");
      if (data !== null) {
        return JSON.parse(data);
      }
    }

    return {
      getUserData,
      getUserName,
      getSubscribeInfo,
      showSuccess,
      toast
    };
  },

  data() {
    return {
      isSubscribed: this.getSubscribeInfo(),
      checked: this.getSubscribeInfo(),
      scores: this.getUserData(),
      name: this.getUserName(),
    };
  },
  methods: {
    unSubscribe: async () => {
      try {
        const json = await axioCred.post(
          `https://www.biletdv.ru/customer/IBEServices/UnsubscribeFromNews`
        );
        let response = await json.data;
        sessionStorage.setItem("roles", JSON.stringify(response.Roles));
        console.log(response);
      } catch (err) {
        console.log(err);
      }
    },
    subscribe: async () => {
      try {
        const json = await axioCred.post(
          `https://www.biletdv.ru/customer/IBEServices/SubscribeForNews`
        );
        let response = await json.data;
        sessionStorage.setItem("roles", JSON.stringify(response.Roles));
        console.log(response);
      } catch (err) {
        console.log(err);
      }
    },
    subscribing() {
      if (this.isSubscribed && !this.checked) {
        this.unSubscribe();
        this.isSubscribed = false;
      } else if (!this.isSubscribed && this.checked) {
        this.subscribe();
        this.isSubscribed = true;
      }
    },
  },
  directives: {
    ripple: Ripple,
  },
  computed: {
    //BonusProgram progress bar
    firstMeter(): number {
      if ((this.scores.Value / 350) * 100 >= 100) {
        return 100;
      } else {
        return (this.scores.Value / 350) * 100;
      }
    },
    secondMeter(): number {
      if (this.scores.Value < 350) {
        return 0;
      } else if ((this.scores.Value / 1000) * 100 >= 100) {
        return 100;
      } else {
        return (this.scores.Value / 1000) * 100;
      }
    },
    thirdMeter(): number {
      if (this.scores.Value < 1000) {
        return 0;
      } else if ((this.scores.Value / 3000) * 100 >= 100) {
        return 100;
      } else {
        return (this.scores.Value / 3000) * 100;
      }
    },

    firstStatus(): any {
      if (this.secondMeter <= 0 && this.thirdMeter <= 0) {
        return true;
      } else {
        return false;
      }
    },
    secondStatus(): any {
      if (this.secondMeter > 0 && this.thirdMeter == 0) {
        return true;
      } else {
        return false;
      }
    },
    thirdStatus(): any {
      if (this.thirdMeter > 0) {
        return true;
      } else {
        return false;
      }
    },
    firstConnectorStyle(): any {
      if (this.firstStatus || this.secondStatus || this.thirdStatus) {
        return `background: linear-gradient(180deg, #289dcc ${
          this.firstMeter + "%"
        }, #dfdfdf 10%)`;
      } else {
        return `background: #dfdfdf`;
      }
    },

    secondConnectorStyle(): any {
      if (this.secondStatus || this.thirdStatus) {
        return `background: linear-gradient(180deg, #289dcc ${
          this.secondMeter + "%"
        }, #dfdfdf 10%)`;
      } else {
        return `background: #dfdfdf`;
      }
    },
    //End of code for bonusProgram progress bar
  },
});
